import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
})
export class PrivacyPolicyComponent implements OnInit {
  @Input() showCard: boolean = true;
  /** When set, parent controls open state (e.g. for accordion – only one open at a time) */
  @Input() isExpanded?: boolean;
  @Output() toggle = new EventEmitter<void>();

  showPrivacyPolicy: boolean = false;

  get expanded(): boolean {
    return this.isExpanded !== undefined ? this.isExpanded : this.showPrivacyPolicy;
  }

  constructor() {}

  ngOnInit() {}

  togglePrivacyPolicy(): void {
    if (this.isExpanded !== undefined) {
      this.toggle.emit();
    } else {
      this.showPrivacyPolicy = !this.showPrivacyPolicy;
    }
  }
}
